// import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  RouterModule,
} from '@angular/router';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { CommonModule } from '@angular/common';
import { QuillModule } from 'ngx-quill';
import { FivGalleryModule , FivCenterModule , FivSpinnerModule} from '@fivethree/core';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgSelectModule } from '@ng-select/ng-select';
// import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import {
  IonicModule,
  IonicRouteStrategy,
} from '@ionic/angular';

// import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedComponentsModule } from './components/shared-components.module';
import { CustomPreloadingStrategy } from './preload/custom-preloading-starategy';
import { IonicStorageModule } from '@ionic/storage-angular';
import {
  initializeApp,
  provideFirebaseApp,
} from '@angular/fire/app';
import {
  getAuth,
  provideAuth,
} from '@angular/fire/auth';
import {
  getDatabase,
  provideDatabase,
} from '@angular/fire/database';
import {
  getFunctions,
  provideFunctions,
} from '@angular/fire/functions';
// import { AngularFireModule } from '@angular/fire/compat';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
// import { TabsPage } from '../pages/tabs/tabs.page'
@NgModule({
  // declarations: [AppComponent],
  declarations: [ AppComponent ],
  // entryComponents: [TestPage,AddpaymentPage,CustomerlistPage,AddressListPage,PopupAttributePage,CashRegisterPage],
  entryComponents: [],
  // CreateCategoryPage
  imports: [
    // CommonModule,
    // YourCartModule
    SharedComponentsModule,
    BrowserModule,
    IonicModule.forRoot({ mode: 'md' }),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    CommonModule,
    // AngularFireModule.initializeApp(environment.firebaseConfig),
    HttpClientModule,
    FormsModule, 
    ReactiveFormsModule, 
    RouterModule,
    NgSelectModule,
    // IonicModule.forRoot(),
    FivGalleryModule,FivCenterModule,FivSpinnerModule,BrowserAnimationsModule,
    QuillModule.forRoot(),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideDatabase(() => getDatabase()),
    provideFunctions(() => getFunctions())
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: environment.production,
    //   registrationStrategy: 'registerWhenStable:30000'
    // }),
  ],
  // SocketIoModule.forRoot(config),
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA],
  
  providers: [
    // StatusBar,
    // SplashScreen,
    // NgbActiveModal,
    // BarcodeScanner,
    // SharedComponentsModule,
    // Storage,
    
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },Storage,Geolocation,
     CustomPreloadingStrategy,AppVersion
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

